import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import * as Actions from '@/app/store/actions';
import { CircularProgress } from '@material-ui/core';
import { deleteEvent } from '@/app/services/events/events';

const DeletEventDailog = ({ row, setRefresh, refresh, setAnchorEl }) => {
	const [isRequesting, setIsRequesting] = useState(false);
	const dispatch = useDispatch();
	return (
		<div className="popup">
			<div>
				<div className="icon-span">
					<h2>!</h2>
				</div>
				<h1 className="disable-text">Are you sure you want to delete ?</h1>
				{isRequesting ? (
					<CircularProgress size={35} />
				) : (
					<>
						<button
							className="no-disable-btn"
							id="no-delete-event-btn"
							onClick={() => dispatch(Actions.closeDialog())}
							type="button"
						>
							No
						</button>

						<button
							className="no-disable-btn"
							id="yes-delete-event-btn"
							onClick={() => {
								setAnchorEl(null);
								setIsRequesting(true);
								deleteEvent(row.id)
									.then((res) => {
										setRefresh(!refresh);
										dispatch(
											Actions.showMessage({
												message: res.data.message,
												autoHideDuration: 1500,
												variant: 'success',
											}),
										);
										dispatch(Actions.closeDialog());
									})
									.catch((err) => {
										dispatch(
											Actions.showMessage({
												message: err.response.data.message,
												variant: 'error',
											}),
										);
										dispatch(Actions.closeDialog());
									})
									.finally(() => {
										setIsRequesting(false);
									});
							}}
							type="button"
						>
							Yes
						</button>
					</>
				)}
			</div>
		</div>
	);
};

export default DeletEventDailog;
